import React, { useCallback, useContext, useMemo } from "react";
import Navigation from "../Components/Navigation";
import { Container } from "react-bootstrap";
import Card from "../Components/Card";
import data from "../data/data.json";
import { SavedContext } from "../App";

const Saved = (props) => {
  const { saved, setSaved } = useContext(SavedContext);

  const addSave = useCallback(
    (key) => {
      if (!saved.includes(key)) {
        setSaved([...saved, key]);
      }
    },
    [saved, setSaved]
  );

  const removeSave = useCallback(
    (key) => {
      const newArray = [];
      saved.map((item) => {
        if (item != key) {
          newArray.push(item);
        }
      });
      setSaved(newArray);
    },
    [saved, setSaved]
  );

  return (
    <div>
      <Navigation />
      <Container style={{ marginTop: "80px" }}>
        {data.map((item, i) => {
          if (saved.includes(item.saveid)) {
            return (
              <Card
                addSave={addSave}
                removeSave={removeSave}
                saveid={item.saveid}
                question={item.text}
                date={item.date}
                answer={item.answer}
                value={item.value}
                topic={item.topic}
                answermedia={item.answermedia}
                textmedia={item.textmedia}
                saved={saved.includes(item.saveid)}
              />
            );
          }
        })}
      </Container>
    </div>
  );
};

export default Saved;
